import * as React from 'react';
import { Trans } from 'react-i18next';
import i18next from 'i18next';

import { Avatar, Button, Modal, Paper } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { useCertifiedFileModalStyles } from './CertifiedFileModal.styles';


import './CertifiedFileModal.scss'

export interface CertifiedFileModalProps {
    open: boolean,
    onClose: Function
}

export const CertifiedFileModal = ( props: CertifiedFileModalProps ) => {
    const { open, onClose } = props;
    const classes = useCertifiedFileModalStyles();

    return (
        <Modal
            disableAutoFocus={ true }
            disableEnforceFocus={ true }
            className="certified-file-modal"
            open={ open }
        >
            <div className="certified-file-modal__root">
                <Paper className="certified-file-modal__content" elevation={ 3 }>
                    <Avatar src="src/assets/img/lock.png" classes={ {
                        root: classes.large,
                        img: classes.img
                    } }>
                    </Avatar>
                    <h2 className="certified-file-modal__content--text-style">
                        <Trans>{
                            i18next.t('default.dashboard.not_allowed_modal.certified_file_is_a_premium_feature')
                        }</Trans>
                    </h2>
                    <div className="certified-file-modal__contact-block" dangerouslySetInnerHTML={ {
                        __html: i18next.t('default.dashboard.not_allowed_modal.ask_for_more_info')
                    } }>
                    </div>
                    <a
                        href={i18next.t('default.dashboard.not_allowed_modal.more_info_certified_file_link')}
                        target="_blank"
                    >
                        <Button
                            variant="outlined"
                            size="medium"
                            color="primary"
                            className={`certified-file-modal--link--style ${classes.button} `}
                        >
                            <Trans>{i18next.t('default.dashboard.not_allowed_modal.more_info')}</Trans>
                        </Button>
                    </a>
                </Paper>
                <CloseIcon onClick={ () => onClose() } classes={ { root: classes.icon } }/>
            </div>
        </Modal>
    );
};